import { LibrariesModel } from '@/models/libraries/libraries';
import { sessionService } from '@/providers/services/auth/session';

export class LibrariesSerializer {

    private static INSTANCE = new LibrariesSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    get session() {
        return sessionService.getSession();
    }

    public normalizeLibraries(payload: any): LibrariesModel[] {
        const Libraries: LibrariesModel[] = [];
        if (payload.libraries.length) {
            payload.libraries.map((library: any) => {
                const thumbnailUrl = this.session ? this.session.cdn_urls.user_cdn_url + library.thumbnail : '';
                const libraryContent: LibrariesModel =  {
                    assessmentCount: library.assessment_count,
                    collectionCount: library.collection_count,
                    courseCount: library.course_count,
                    description: library.description,
                    id: library.id,
                    name: library.name,
                    offlineActivityCount: library.offline_activity_count,
                    questionCount: library.question_count,
                    resourceCount: library.resource_count,
                    rubricCount: library.rubricCount,
                    sequenceId: library.sequence_id,
                    shortName: library.short_name,
                    taskCount: library.task_count,
                    tenant: library.tenant,
                    thumbnail: thumbnailUrl,
                };
                Libraries.push(libraryContent);
            });
        }
        return Libraries;

    }

}

export const librariesSerializer = LibrariesSerializer.instance;
